import { Storage } from "aws-amplify";

/** プリセット画像一覧を取得します。 */
export async function listPublicImages(marker = null) {
  const res = (await Storage.list("shared/images/characters/", {
    level: "public",
  })) as [];
  return {
    nextMarker: null,
    contents: res,
  };
}

export async function downloadPublicImage(key: string) {
  const result = await Storage.get(key, {
    level: "public",
  });
  return result;
}

export async function saveBinary(key: string, binary: Buffer | Blob) {
  const result = await Storage.vault.put(key, binary);
  return result;
}

export async function deleteBinary(key: string) {
  const result = await Storage.vault.remove(key);
  return result;
}

export function getCharacterKey(novelId: string, character: any) {
  const { characterId, image } = character;
  if (!image) {
    return null;
  }
  if (image.startsWith("file:")) {
    return `file:novels/${novelId}/characters/${characterId}.jpg`;
  }
  return image;
}

export function getWorldViewlKey(novelId: string, worldView: any) {
  const { worldViewId, image } = worldView;
  if (!image) {
    return null;
  }
  if (image.startsWith("file:")) {
    return `file:novels/${novelId}/worldviews/${worldViewId}.jpg`;
  }
  return image;
}

/**
 * S3から画像、音声、動画、PDF、実行ファイルなどの非テキストファイルのバイナリデータを取得する関数。
 * オブジェクトが存在する場合はバイナリ形式のデータ（Buffer）を返します。
 * 存在しない場合は null を返します。
 */
export async function fetchS3BinaryData(s3Key: string): Promise<Buffer | null> {
  try {
    // Storage.vault.getでS3の認証済みユーザー専用のオブジェクトにアクセスし、データを取得
    const s3Object = (await Storage.vault.get(s3Key, { download: true, expires: 0 })) as any;
    return s3Object.Body;
  } catch (error: any) {
    if (error.name === "NoSuchKey" || (error.response && error.response.status === 404)) {
      console.log("S3 Object not found.");
      return null; // オブジェクトが存在しない場合
    }
    console.error("Error fetching S3 object:", error);
    throw error; // その他のエラー
  }
}
